import React, { ReactElement, useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Popover, Row } from 'antd';
import {
  ALLOWED_FILE_TYPES,
  CLAIM_VIEW,
  DEFAULT_TABLE_CONFIGS,
  DEFAULT_DATE_FILTER,
  FILES_UPLOAD_SUCCESSFULL_TEXT,
  GUTTOR_SPACE,
  HORIZONTAL_SCROLL_POPOVER,
  PRE_AUTH_CONFIGS_TO_BE_REMOVED,
  PRE_AUTH_CONFIGS_TO_BE_REMOVED_NEW_TPA,
  PRE_AUTH_VIEW,
  SUCCESS_AND_FAILURE_MESSAGES,
  TPA_BANNER_TEXT,
  CLAIM_VIEW_CONFIGS_TO_BE_REMOVED,
} from '../../../../shared/constants/commonConstants';
import { INPATIENT_SUB_FILTERS } from '../../../../shared/constants/crmConstants';
import FilterAutoComplete from '../../../../shared/components/FilterAutocomplete/FilterAutoComplete';
import TableConfigurator from '../../../../shared/components/TableConfigurator/TableConfigurator';

import CheckableTag from 'antd/lib/tag/CheckableTag';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { ApplicationDetailModel } from '../../../../store/models/applicationDetailModel';
import {
  searchInPatientList,
  setIsDownloadClaimsModalOpen,
  setIsUploadClaimReportModalOpen,
  setPageIndex,
  setTPASecondaryFilter,
  setUploadedFiles,
} from '../../../../store/actions/inPatientAction';
import { ReactComponent as DownloadCtx } from '../../../../assets/images/svg/Download-Ctx.svg';
import { ReactComponent as DownloadFilteredData } from '../../../../assets/images/svg/DownloadFilteredDataIcon.svg';
import { ReactComponent as HorizontalScrollLeftIcon } from '../../../../assets/images/svg/HorizontalScrollLeftIcon.svg';
import { ReactComponent as HorizontalScrollRightIcon } from '../../../../assets/images/svg/HorizontalScrollRightIcon.svg';
import { ReactComponent as HorizontalScrollDisabledLeftIcon } from '../../../../assets/images/svg/HorizontalScrollDisabledLeftIcon.svg';
import { ReactComponent as HorizontalScrollDisabledRightIcon } from '../../../../assets/images/svg/HorizontalScrollDisabledRightIcon.svg';
import { ReactComponent as UploadCtx } from '../../../../assets/images/svg/Upload-Ctx.svg';
import DownloadClaimsModal from '../../../../shared/components/tags/DownloadClaimsModal';
import { downloadReconciliationFile } from '../../../../store/actions/reconciliationAction';
import { ReactComponent as RoundTickIcon } from '../../../../assets/images/svg/i_round_tick.svg';
import { ReactComponent as DownloadFilteredClaimsCancelicon } from '../../../../assets/images/svg/DownloadFilteredClaimsCancelicon.svg';
import FileUploader from '../../../../shared/components/tags/FileUploader';
import { GLOBAL_URL } from '../../../../shared/constants/dataServiceUrl';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import {
  centeredNotification,
  combineDateAndTime,
  controlHorizontalScroll,
  convertUtcToIst,
  filterDateFilterOnly,
} from '../../../../utils/utility';
import '../../../../index.less';
import {
  customGTMEvent,
  displayViewText,
  filteredObjects,
  convertToISOStrings,
  formatSelectedFilter,
} from '../service/crmUtils';
import SecondaryFilters from '../../../../shared/components/tags/SecondaryFilter';
import { isEmpty } from 'lodash';

const InpatientListSubFilters = (props: any): ReactElement => {
  const {
    setLoaderStateValue,
    autoCompleteRef,
    searchForm,
    inPatientTableMapping,
    onColumnEditSave,
    secondaryFilterData,
    totalSecondClaimCountData,
    isCountClickedData,
    handleSecondaryFilter,
    availableTpaSecondaryFilter,
    resetSecondaryFilters,
    getScrollContainer,
    inPatientCasesDataCount,
  } = props;
  const defaultConfigurations = filteredObjects(inPatientTableMapping, DEFAULT_TABLE_CONFIGS);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const appDetail: ApplicationDetailModel = useSelector(
    (state: RootState): ApplicationDetailModel => state?.applicationDetail || {},
  );
  const {
    tpaSecondaryFilter,
    timeFilter,
    uploadedFiles,
    isPreAuthView,
    viewCounts,
    searchDataVisible,
    isTblLoading,
    tpaDeskSecondaryFilter,
    tpaNextStatus,
    isDownloadClaimsModalOpen,
    isUploadClaimReportModalOpen,
    showTpaStartDateAndTime,
    showTpaEndDateAndTime,
    isFilteredPopoverVisible,
    isDraftBtnClicked,
    filters,
  } = useSelector(
    (state: RootState): any => state?.selectedInPatientDetail || {},
  );
  const isDownloadClaimEnabled =
    ApplicationDetail.instance.getIsDownloadClaimEnabled();
  const groupProviders = appDetail.getGroupProviders();
  const isNewTpaActiveForGroupProvider = appDetail.getIsNewTpaActiveForGroupProvider();
  const groupProvidersPresent = !isEmpty(groupProviders);
  const isNewTpaDeskEnabled = appDetail.getIsNewTpaDeskEnabled();
  const isPreAuthClaimViewEnabled = appDetail?.getIsPreAuthClaimViewEnabled();
  const preAuthViewConfigurations =
    (isPreAuthClaimViewEnabled && isNewTpaDeskEnabled)
      ? filteredObjects(inPatientTableMapping, PRE_AUTH_CONFIGS_TO_BE_REMOVED_NEW_TPA)
      : filteredObjects(inPatientTableMapping, PRE_AUTH_CONFIGS_TO_BE_REMOVED);
  const claimViewConfigurations =
    (isPreAuthClaimViewEnabled && isNewTpaDeskEnabled)
      ? inPatientTableMapping
      : filteredObjects(
          inPatientTableMapping,
          CLAIM_VIEW_CONFIGS_TO_BE_REMOVED,
        );
  const [downloadClaimsButtonEnabled, setDownloadClaimsButtonEnabled] =
    useState(false);
  const [selectedPayers, setSelectedPayers] = useState([]);
  const [downloadClaimsLoader, setDownloadClaimsLoader] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [successModalText, setSuccessModalText] = useState('');
  const [horizontalLeftScrollClicked, setHorizontalLeftScrollClicked] =
    useState(false);
  const [horizontalRightScrollClicked, setHorizontalRightScrollClicked] =
    useState(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [uploadFilesLoader, setUploadFilesLoader] = useState(false);
  const [isHoveredDownloadFltrClaim, setIsHoveredDownloadFltrClaim] = useState(
    isFilteredPopoverVisible || false,
  );
  const uploadFilesCancel = (): any => {
    dispatch(setIsUploadClaimReportModalOpen(false));
    dispatch(setUploadedFiles([]));
  };

  const checkScrollAvailability = (): void => {
    const scrollContainer = getScrollContainer();
    if (scrollContainer) {
      setCanScrollLeft(scrollContainer.scrollLeft > 0);
      setCanScrollRight(
        scrollContainer.scrollLeft + scrollContainer.clientWidth <
          scrollContainer.scrollWidth,
      );
    }
  };

  useEffect((): any => {
     const scrollContainer = getScrollContainer();
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', checkScrollAvailability);
      setTimeout(checkScrollAvailability, 100); // Initial check after short delay
    }
    return (): void => {
      scrollContainer?.removeEventListener('scroll', checkScrollAvailability);
    };
  }, [inPatientTableMapping, preAuthViewConfigurations, claimViewConfigurations]);

  useEffect((): any => {
    if (isSuccessModalOpen) {
      setTimeout((): any => {
        setIsSuccessModalOpen(false);
        dispatch(setIsUploadClaimReportModalOpen(false));
        dispatch(setIsDownloadClaimsModalOpen(false));
        form.resetFields();
      }, 3500);
    }
  }, [isSuccessModalOpen]);

  const appDetailService = ApplicationDetail.instance;

  const submitUploadedFiles = (): any => {
    if (uploadedFiles.length > 0) {
      customGTMEvent({
        event: 'Click on Upload claims button',
      });
      setUploadFilesLoader(true);
      const formData = new FormData();
      uploadedFiles.forEach((file: any): any => {
        formData.append('File', file['originFileObj']);
      });
      formData.append('ProviderId', appDetailService.getProviderId());
      fetch(
        `${GLOBAL_URL.CRM_BASE_URL}Provider/Claim/AddHospActionManualData`,
        {
          method: 'POST',
          // headers: { accessToken: appDetailService.getAccessToken() },
          body: formData,
          credentials: 'include',
        },
      )
        .then((response: any): any => response.json())
        .then((response: any): any => {
          setUploadFilesLoader(true);
          if (response.isSuccess) {
            setUploadFilesLoader(false);
            setIsSuccessModalOpen(true);
            setSuccessModalText(FILES_UPLOAD_SUCCESSFULL_TEXT);
            dispatch(setUploadedFiles([]));
          } else {
            setUploadFilesLoader(false);
            const error = response.Errors || response.errors;
            centeredNotification(error?.join(',\n'));
          }
        })
        .catch((err: any): any => centeredNotification(err));
      return null;
    }
  };

  const onSecondaryFilterClick = (ev: any, selected2ndFilter: string): void => {
    dispatch(setPageIndex(1));
    dispatch(setTPASecondaryFilter(selected2ndFilter));
    dispatch(searchInPatientList());
  };

  const downloadClaims = (): any => {
    if (downloadClaimsButtonEnabled) {
      customGTMEvent({
        event: 'Click on Download claims button',
      });
      const payload = {
        payers: selectedPayers,
        fromDate: form.getFieldValue('From').startOf('day').format(),
        toDate: form.getFieldValue('To').startOf('day').format(),
      };
      dispatch(
        downloadReconciliationFile({
          payload,
          url: TPA_BANNER_TEXT.DOWNLOAD_FILTERED_CLAIM_URL,
          extension: 'csv',
          onSuccess: (): any => {
            setDownloadClaimsLoader(false);
            setIsSuccessModalOpen(true);
            setSelectedPayers([]);
            setSuccessModalText(
              SUCCESS_AND_FAILURE_MESSAGES.FILE_SUCCESSFULLY_DOWNLOADED,
            );
          },
          onError: (): any => {
            setDownloadClaimsLoader(false);
          },
        }),
      );
      setDownloadClaimsLoader(true);
    }
  };

  const downloadFilteredData = (): any => {
    customGTMEvent({
      event: 'TPA Download Filtered Data',
    });
    const startDate = combineDateAndTime(
      showTpaStartDateAndTime?.date,
      showTpaStartDateAndTime?.time,
    );
    const endDate = combineDateAndTime(
      showTpaEndDateAndTime?.date,
      showTpaEndDateAndTime?.time,
    );
    const convertedIsoDate = convertToISOStrings([startDate, endDate]);
    const { dateFilter } = filters;
    const finalFilters = {
      ...filters,
      dateFilter:
        Array?.isArray(dateFilter) && dateFilter?.length > 0
          ? dateFilter
          : DEFAULT_DATE_FILTER,
    };
    const payload = {
      primaryFilter: tpaNextStatus ? tpaNextStatus : null,
      filters: filterDateFilterOnly(formatSelectedFilter(finalFilters)),
      tpaDeskSecondaryFilter,
      fromDate: convertUtcToIst(convertedIsoDate?.[0]),
      toDate: convertUtcToIst(convertedIsoDate?.[1]),
      isNewTpaDeskEnabled,
      viewType: isPreAuthView ? PRE_AUTH_VIEW : CLAIM_VIEW,
    };

    dispatch(
      downloadReconciliationFile({
        payload,
        url: TPA_BANNER_TEXT.DOWNLOAD_FILTERED_CLAIM_URL,
        extension: 'csv',
        onSuccess: (): any => {
          setDownloadClaimsLoader(false);
          setSelectedPayers([]);
          setSuccessModalText(
            SUCCESS_AND_FAILURE_MESSAGES.FILE_SUCCESSFULLY_DOWNLOADED,
          );
        },
        onError: (): any => {
          setDownloadClaimsLoader(false);
        },
      }),
    );
    setDownloadClaimsLoader(true);
  };
const tableMapping =
  isNewTpaDeskEnabled && isPreAuthClaimViewEnabled
    ? isPreAuthView
      ? preAuthViewConfigurations
      : inPatientTableMapping
    : isPreAuthClaimViewEnabled
    ? isPreAuthView
      ? preAuthViewConfigurations
      : claimViewConfigurations
    : defaultConfigurations;

const configuration = isPreAuthClaimViewEnabled
  ? isPreAuthView
    ? appDetail?.getIPPreAuthViewConfig()
    : appDetail?.getIPClaimViewConfig()
  : appDetail?.getIPConfig();

  const getClaimCount = (subFilterKey: string): string => {
    const count = secondaryFilterData?.[timeFilter]?.[subFilterKey];
    if (count !== undefined || !isCountClickedData) {
      return count ?? '0';
    }
    return totalSecondClaimCountData?.[subFilterKey] ?? '0';
  };

  return (
    <Form form={searchForm}>
      {!isNewTpaDeskEnabled && (
        <Row
          className="inpatient-list-sub-filters"
          gutter={GUTTOR_SPACE}
          justify="space-between"
        >
          <Row>
            {!isTblLoading && searchDataVisible && (
              <span className="inpatient-loading-contents">
                {displayViewText(isPreAuthView)} Results (
                {isPreAuthView
                  ? viewCounts?.preAuthViewClaimCount
                  : viewCounts?.claimViewClaimCount}
                )
              </span>
            )}
          </Row>
          {
            <Col className="content-center">
              {process.env.REACT_APP_IS_TPA_SECONDARY_FILTER === 'true' &&
                INPATIENT_SUB_FILTERS.map(
                  ({
                    id,
                    label,
                    key,
                  }: {
                    id: string;
                    label: string;
                    key: string;
                  }): ReactElement => {
                    const isSelected = tpaSecondaryFilter === id;
                    const count = getClaimCount(key);
                    return (
                      <CheckableTag
                        key={id}
                        checked={isSelected}
                        onClick={(checked: any): void =>
                          onSecondaryFilterClick(checked, id)
                        }
                        className={isSelected ? 'selected' : ''}
                      >
                        {label} ({count})
                      </CheckableTag>
                    );
                  },
                )}
            </Col>
          }
          <Col
            className={`${
              (groupProvidersPresent && !isNewTpaActiveForGroupProvider) && 'inpatient-subFilters-group-login'
            }
                `}
          >
            <Row gutter={GUTTOR_SPACE} justify="end">
              {isDownloadClaimEnabled && (
                <>
                  <Col className="flex flex-element justify-center align-center downloadctx">
                    <Popover
                      content={
                        <span className="inpatient_tooltip_header">
                          {TPA_BANNER_TEXT.UPLOAD_CLAIM_TOOL_TIP_TITLE}
                        </span>
                      }
                      placement="bottom"
                    >
                      <UploadCtx
                        className="mouse-pointer"
                        onClick={(): any => {
                          dispatch(setIsUploadClaimReportModalOpen(true));
                        }}
                      />
                    </Popover>
                  </Col>
                  <Col className="flex flex-element justify-center align-center downloadctx">
                    <Popover
                      content={
                        <span className="inpatient_tooltip_header">
                          {TPA_BANNER_TEXT.DOWNLOAD_OPEN_CLAIM_TOOL_TIP_TITLE}
                        </span>
                      }
                      placement="bottom"
                    >
                      <DownloadCtx
                        className="mouse-pointer"
                        onClick={(): any => {
                          dispatch(setIsDownloadClaimsModalOpen(true));
                        }}
                      />
                    </Popover>
                  </Col>
                </>
              )}
              {(!groupProvidersPresent) ? (
                <>
                  <Col>
                    <FilterAutoComplete
                      setLoaderStateValue={setLoaderStateValue}
                      ref={autoCompleteRef}
                      form={searchForm}
                    />
                  </Col>
                  <Col>
                <TableConfigurator
                  tableMapping={tableMapping}
                  saveClickHandler={onColumnEditSave}
                  configuration={configuration}
                />
                  </Col>
                </>
              ) : (
                <></>
              )}
            </Row>
          </Col>
        </Row>
      )}
      {isPreAuthClaimViewEnabled && isNewTpaDeskEnabled && (
      <div className="inpatient-list-sub-filters p-0 new-inpatient-list-sub-filters">
        <div className="inpatient-list-secondary-filters">
            <SecondaryFilters
              filters={availableTpaSecondaryFilter}
              handleSecondaryFilter={handleSecondaryFilter}
              resetSecondaryFilters={resetSecondaryFilters}
              inPatientCasesDataCount={inPatientCasesDataCount}
            />
        </div>
          <div className="inpatient-list-secondary-filter-menu">
            <Popover
                visible={isHoveredDownloadFltrClaim}
                onVisibleChange={(hovered: any): any =>
                  setIsHoveredDownloadFltrClaim(hovered)
                }
                content={
                  <>
                    <div className="downloadFilterIconTooltip_header">
                      {TPA_BANNER_TEXT.DOWNLOAD_FILTERED_CLAIMS_TOOL_TIP_TITLE}
                      <DownloadFilteredClaimsCancelicon
                        onClick={(): void =>
                          setIsHoveredDownloadFltrClaim(false)
                        }
                        style={{ cursor: 'pointer' }}
                      />
                    </div>
                    <hr className="downloadFilterIconTooltip_hr" />
                    <div className="downloadFilterIconTooltip_body">
                      {
                        TPA_BANNER_TEXT.PRE_DOWNLOAD_FILTERED_CLAIMS_TOOL_TIP_CONTENT
                      }
                      <span>
                        {
                          TPA_BANNER_TEXT.DOWNLOAD_FILTERED_CLAIMS_TOOL_TIP_CONTENT
                        }
                      </span>
                      {
                        TPA_BANNER_TEXT.POST_DOWNLOAD_FILTERED_CLAIMS_TOOL_TIP_CONTENT
                      }
                    </div>
                  </>
                }
                placement="bottom"
                overlayClassName="custom-download-popover blinks"
                getPopupContainer={(trigger: HTMLElement): HTMLElement =>
                  trigger.parentNode as HTMLElement
                }
              >
                <DownloadFilteredData
                  className={`mouse-pointer ${isDraftBtnClicked && `expired`} `}
                  onClick={downloadFilteredData}
                />
              </Popover>
              <TableConfigurator
                tableMapping={
                  isPreAuthClaimViewEnabled
                    ? isPreAuthView
                      ? preAuthViewConfigurations
                      : inPatientTableMapping
                    : defaultConfigurations
                }
                saveClickHandler={onColumnEditSave}
                configuration={
                  isPreAuthClaimViewEnabled
                    ? isPreAuthView
                      ? appDetail?.getIPPreAuthViewConfig()
                      : appDetail?.getIPClaimViewConfig()
                    : appDetail?.getIPConfig()
                }
              />
              <Popover
                onVisibleChange={(hover: any): void =>
                  setHorizontalLeftScrollClicked(hover)
                }
                visible={horizontalLeftScrollClicked}
                content={
                  <>
                    <div className="downloadFilterIconTooltip_header">
                      {HORIZONTAL_SCROLL_POPOVER.HEADER}
                    </div>
                    <hr className="downloadFilterIconTooltip_hr" />
                    <div className="downloadFilterIconTooltip_body width_185">
                      {HORIZONTAL_SCROLL_POPOVER.LEFT_TEXT}
                    </div>
                  </>
                }
                autoAdjustOverflow={false}
                placement="bottomRight"
                overlayClassName="custom-download-popover"
                getPopupContainer={(trigger: HTMLElement): HTMLElement =>
                  trigger.parentNode as HTMLElement
                }
              >
                {canScrollLeft ? (
                  <HorizontalScrollLeftIcon
                    className={`mouse-pointer`}
                    onClick={(): void => {
                      controlHorizontalScroll(getScrollContainer, 'left');
                      setHorizontalLeftScrollClicked(false);
                    }}
                  />
                ) : (
                  <HorizontalScrollDisabledLeftIcon className="noMousePointer" />
                )}
              </Popover>

              <Popover
                onVisibleChange={(hover: any): void =>
                  setHorizontalRightScrollClicked(hover)
                }
                visible={horizontalRightScrollClicked}
                content={
                  <>
                    <div className="downloadFilterIconTooltip_header">
                      {HORIZONTAL_SCROLL_POPOVER.HEADER}
                    </div>
                    <hr className="downloadFilterIconTooltip_hr" />
                    <div className="downloadFilterIconTooltip_body width_185">
                      {HORIZONTAL_SCROLL_POPOVER.RIGHT_TEXT}
                    </div>
                  </>
                }
                autoAdjustOverflow={false}
                placement="bottomRight"
                overlayClassName="custom-download-popover"
                getPopupContainer={(trigger: HTMLElement): HTMLElement =>
                  trigger.parentNode as HTMLElement
                }
              >
                {canScrollRight ? (
                  <HorizontalScrollRightIcon
                    onClick={(): void => {
                      controlHorizontalScroll(getScrollContainer, 'right');
                      setHorizontalRightScrollClicked(false);
                    }}
                    className={`mx-5 mouse-pointer`}
                  />
                ) : (
                  <HorizontalScrollDisabledRightIcon className="mx-5 noMousePointer" />
                )}
              </Popover>
            </div>
      </div>
      )}

      <div>
        {isDownloadClaimsModalOpen && (
          <Modal
            visible={isDownloadClaimsModalOpen}
            title={
              <div className="flex flex-element">
                <Row
                  gutter={GUTTOR_SPACE}
                  justify="start"
                  className="items-baseline"
                >
                  <div className="bold ml-10">
                    {TPA_BANNER_TEXT.DOWNLOAD_OPEN_CLAIM_TOOL_TIP_TITLE}
                  </div>
                  <div className="fsize_sm mx-1">
                    ({TPA_BANNER_TEXT.FOR_15_DAYS})
                  </div>
                </Row>
              </div>
            }
            onCancel={(): any => {
              dispatch(setIsDownloadClaimsModalOpen(false));
              form.resetFields();
              setSelectedPayers([]);
            }}
            footer={
              <Button
                data-testid="cancel-submit"
                loading={downloadClaimsLoader}
                type="primary"
                disabled={!downloadClaimsButtonEnabled}
                onClick={(): any => downloadClaims()}
              >
                Download
              </Button>
            }
          >
            <DownloadClaimsModal
              form={form}
              setDownloadClaimsButtonEnabled={setDownloadClaimsButtonEnabled}
              setSelectedPayers={setSelectedPayers}
            />
          </Modal>
        )}
        {isUploadClaimReportModalOpen && (
          <Modal
            visible={isUploadClaimReportModalOpen}
            width={680}
            title={
              <div className="mx-10">
                <Row gutter={GUTTOR_SPACE} justify="start" align="middle">
                  <div className="bold">
                    {TPA_BANNER_TEXT.UPLOAD_CLAIM_TOOL_TIP_TITLE}
                  </div>
                </Row>
                <Row gutter={GUTTOR_SPACE} justify="start" align="middle">
                  <div className="fsize_sm">
                    ({TPA_BANNER_TEXT.WITH_IP_NUMBER})
                  </div>
                </Row>
              </div>
            }
            onCancel={uploadFilesCancel}
            footer={
              <Button
                data-testid="cancel-submit"
                disabled={uploadedFiles.length <= 0}
                type="primary"
                loading={uploadFilesLoader}
                onClick={(): any => submitUploadedFiles()}
              >
                Submit
              </Button>
            }
          >
            <div className="flex flex-element flex-col file-container">
              <FileUploader
                allowedFileTypes={
                  ALLOWED_FILE_TYPES.INPATIENT_SUBFILTER_UPLOAD_FILES
                }
                isDocumentTypeRequired={false}
              />
            </div>
          </Modal>
        )}
        {isSuccessModalOpen && (
          <Modal
            visible={isSuccessModalOpen}
            footer={null}
            className="flex flex-element justify-center align-center success-modal"
            onCancel={(): any => setIsSuccessModalOpen(false)}
          >
            <div className="flex flex-element flex-col file-container">
              <div>
                <Row gutter={GUTTOR_SPACE} justify="center" className="mb-sm">
                  <strong>
                    <RoundTickIcon className="fill-success" />
                  </strong>
                </Row>
                <Row gutter={GUTTOR_SPACE} justify="center" className="mb-sm">
                  <strong className="text-success">{successModalText}</strong>
                </Row>
              </div>
            </div>
          </Modal>
        )}
      </div>
    </Form>
  );
};

export default InpatientListSubFilters;
